import { Suspense, lazy } from 'react';
import { ActionButton } from '@practium/ui';
import styles from './SystemStatusCard.module.css';

const CoffeGreen = lazy(() =>
	import('../../3D/CoffeGreen').then((m) => ({ default: m.CoffeGreen }))
);
const CoffeRed = lazy(() => import('../../3D/CoffeRed').then((m) => ({ default: m.CoffeRed })));

interface SystemStatusCardProps {
	healthy?: boolean;
	isLoading?: boolean;
	onReportClick?: () => void;
}

export const SystemStatusCard = ({
	healthy,
	isLoading = false,
	onReportClick,
}: SystemStatusCardProps) => {
	const statusText = isLoading
		? 'Carregando...'
		: healthy === undefined
			? 'Indisponível'
			: healthy
				? 'Saudável'
				: 'Instável';
	const statusClass =
		isLoading || healthy === undefined
			? styles.statusTextNeutral
			: healthy
				? styles.statusTextHealthy
				: styles.statusTextUnstable;

	return (
		<div className={styles.card}>
			<div className={styles.backgroundWrapper}>
				<Suspense fallback={<div className={styles.imageFallback} />}>
					{healthy === false ? <CoffeRed /> : <CoffeGreen />}
				</Suspense>
			</div>

			<div className={styles.content}>
				<div className={styles.header}>
					<p className={styles.title}>Status do Sistema</p>
					<div className={styles.actionWrapper}>
						<ActionButton  text="Ver Relatório" onClick={onReportClick || (() => {})} />
					</div>
				</div>
				<div className={styles.status}>
					<span
						className={`${styles.statusText} ${statusClass}`}
					>
						{statusText}
					</span>
				</div>
			</div>
		</div>
	);
};
